import React from "react";
import LoginForm from "../LoginForm";
import AuthSplitLayout from "../../../layouts/AuthSplitLayout";
import Flex from "../../common/Flex";
import bgImage from "../../../assets/img/log-in/image_web.png";

const Login = () => (
  <AuthSplitLayout bgProps={{ image: bgImage, position: "50% 60%" }}>
    <Flex alignItems="center" justifyContent="center" className="mb-3">
      <h3>Log in</h3>
    </Flex>
    <LoginForm layout="split" hasLabel={false} />
  </AuthSplitLayout>
);

export default Login;
